module.exports = __webpack_public_path__ + "img/tiscapa.28145a48.jpg";